/**
 * Created by bootdo.
 * 用户相关api
 */
import * as API from './'
import $const from "../common/constant"


export default {
  /**
   * 获取当前登陆用户信息
   * @param params
   * @returns {Promise<*>}
   */
  currentUserInfo: params => {
    return API.GET($const.apiServer.Admin + '/user/currentUserInfo', params)
  } ,
  //验证身份证是否有效
  checkIdentity: params => {
    return API.GET($const.apiServer.Admin + '/user/checkIdentity', params)
  } ,
  //登录
  login: params => {
    return API.POST($const.apiServer.Admin + '/oauth/token', params)
  },
  //登出
  logout: params => {
    return API.GET($const.apiServer.Admin + '/user/logout', params)
  },
  tokenUser: params => {
    return API.GET($const.apiServer.Admin + '/user/currentUser', params)
  },
  //修改个人信息
  changeProfile: params => {
    return API.PATCH('/api/v1/users/profile', params)
  },
  //查询获取user列表(通过page分页)
  findList: params => {
    return API.GET($const.apiServer.Admin + '/user', params)
  },
  pageList: params => {
    return API.GET($const.apiServer.Admin + '/user/pageList', params)
  },
  pageList2: params => {
    return API.GET($const.apiServer.Admin + '/user/roleUserList', params)
  },
  //查询获取user列表(通过page分页)
  getByDeptOrEnt: params => {
    return API.GET($const.apiServer.Admin + '/user/getByDeptOrEnt', params)
  },

  //查询获取user列表(通过page分页)
  listNormalUser: params => {
    return API.GET($const.apiServer.Admin + '/user/listNormalUser', params)
  },

  //增加用户
  addUser: params => {
    return API.POST($const.apiServer.Admin + '/user/addUser', params)
  },
  //增加用户
  saveUser: params => {
    return API.POST($const.apiServer.Admin + '/user/saveUsers', params)
  },
  //修改用户
  editUser: params => {
    return API.POST($const.apiServer.Admin + '/user/update', params)
  },
  //删除用户
  removeUser: params => {
    return API.GET($const.apiServer.Admin + '/user/del/users', params)
  },

  router: params => {
    return API.GET($const.apiServer.Admin + '/router', params)
  },
  //查询用户是否存在
  exits: params => {
    return API.GET($const.apiServer.Admin + '/user/exits', params)
  },
  //查询用户是否存在
  resetPwd: params => {
    return API.GET($const.apiServer.Admin + '/user/resetPwd', params)
  },
  //无分页查询用户
  listNopagging: params => {
    return API.GET($const.apiServer.Admin + '/user/listNopagging', params)
  },
  //多部门查询用户
  listByDeptIds: params => {
    return API.GET($const.apiServer.Admin + '/user/listByDeptIds', params)
  },
  //分页,查询用户,仅仅只查询本公司的用户
  listOfSelfEnt: params => {
    return API.GET($const.apiServer.Admin + '/user/listOfSelfEnt', params)
  },
  //获取带角色的用户列表
  listUserEnt: params => {
    return API.GET($const.apiServer.Admin + '/user/listUserEnt', params)
  },


  updatePwd: params => {
    return API.POST($const.apiServer.Admin + '/user/updatePwd', params)
  },
  getUser: id => {
    // return API.GET($const.apiServer.Admin + '/user/getUser/' + id)
    return API.GET($const.apiServer.Admin + '/user/getLoginUser' )
  },
  updateUser: params => {
    return API.POST($const.apiServer.Admin + '/user/updateUser', params)
  },
  newUpdateUser: params => {
    return API.POST($const.apiServer.Admin + '/user/newUpdateUser', params)
  },
  //查询获取user列表(通过page分页)
  getPagedByDeptOrEnt: params => {
    return API.GET($const.apiServer.Admin + '/user/getPagedByDeptOrEnt', params)
  },
  //查询用户列表
  getByDept: params => {
    return API.GET($const.apiServer.Admin + '/user/getByDept', params)
  },

  /**
   * 根据角色Id和企业Id 查询用户(企业ID后台取值)
   *
   * @param roleId 角色Id
   * @return
   */
  selectUserList: params => {
    return API.GET($const.apiServer.Admin + '/user/selectUserList', params)
  },

  /**
   * 保存用户和角色关系
   * @param userRoleDO
   * @return
   */
  saveUserRole: params => {
    return API.POST($const.apiServer.Admin + '/user/saveUserRole', params)
  },

  /**
   * 删除用户和角色关系
   * @param id
   * @return
   */
  removeUserRoleById: id => {
    return API.POST($const.apiServer.Admin + '/user/removeUserRoleById?id=' + id)
  },

  /**
   * 查询更新公告数据
   */
  selectIsShowAnnouncement: params => {
    return API.GET($const.apiServer.Admin + '/announcement/selectIsShowAnnouncement', params)
  },
  detectionChangeTime: params => {
    return API.GET($const.apiServer.Admin + '/user/detection-change-time', params)
  },
  saveOrg: params => {
    return API.POST($const.apiServer.Admin + '/org' + (params.id ? '/update' : ''), params)
  },
  getOrg: params => {
    return API.GET($const.apiServer.Admin + '/org', params)
  },
  //删除用户
  removeOrg: params => {
    return API.GET($const.apiServer.Admin + '/org/del', params)
  },
  //删除用户
  getOrigManagers: params => {
    return API.GET($const.apiServer.Admin + '/org/list-managers', params)
  },
  postOrigManagers: params => {
    return API.POST($const.apiServer.Admin + '/org/bind-managers', params)
  },
  postOrigManagersV2: params => {
    return API.POST($const.apiServer.Admin + '/org/bind-managers-v2', params)
  },
  batchUpdateUser: params => {
    return API.POST($const.apiServer.Admin + '/user/batchUpdate', params)
  },
  qywxLogin: params => {
    return API.GET($const.apiServer.Admin + '/oauth/qywxLogin', params)
  },
  orgGetTree: params => {
    return API.GET($const.apiServer.Admin + '/org/getTree', params)
  },
  orgUserListAll: params => {
    return API.GET($const.apiServer.Admin + '/user/orgUserListAll/' + params.id, params)
  },
  getPostEnList: params => {
    return API.GET($const.apiServer.Admin + '/user/getPostEnList', params)
  },
  getPostList: params => {
    return API.GET($const.apiServer.Admin + '/user/getPostList', params)
  },
  getRoleList: params => {
    return API.POST($const.apiServer.Admin + '/role/pageList', params)
  },
  //同步企微资料
  syncUserFromWxWork: params => {
    return API.POST($const.apiServer.Admin + '/user/syncUserFromWxWork?queryDate=' + params.queryDate)
  },
}


// WEBPACK FOOTER //
// ./src/api/api_user.js